import React, { useState, useEffect, useRef } from "react";

import { Table, Tooltip, Tag, Input, Button, Space, message } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { getProductInventoryLog } from "../../../Redux/actions/inventoryActions";
import { errorParser, numberWithCommas } from "../../../utils/helpers";

const Index = ({ branchID, productID, product, onSendData }) => {
  const dispatch = useDispatch();

  const {} = useSelector((state) => ({}), shallowEqual);
  const [data, setData] = useState([]);
  const [sorter, setSorter] = useState(null);
  const [filterArray, setFilterArray] = useState([]);
  const [filterText, setFilterText] = useState(null);
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [defaultpageSize, setDefaultPageSize] = useState(50);
  const [range, setRange] = useState([1, 50]);
  const [pageSizeOptions, setPageSizeOptions] = useState([75, 100, 500, 1000]);

  const getTableData = async () => {
    setLoading(true);

    var newdata = await dispatch(getProductInventoryLog(branchID, productID));
    setData(newdata);
    onSendData(newdata);
    setLoading(false);
  };

  useEffect(() => {
    if (branchID && productID) {
      getTableData();
    }
  }, []);

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record, index) => {
        return moment(text).format("LL hh:mm:ss a");
      },
    },
    {
      title: "User",
      dataIndex: "created_name",
      key: "created_name",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Change",

      render: (text, record, index) => {
        var state = 0;
        console.log("record", record);
        if (data[index + 1]) {
          if (
            (data[index]?.quantity && data[index + 1]?.quantity) ||
            data[index]?.quantity == 0 ||
            data[index + 1]?.quantity == 0
          ) {
            if (data[index].quantity > data[index + 1].quantity) {
              return (
                <div className="color-green">
                  ↑ ({" "}
                  {(data[index].quantity - data[index + 1].quantity).toFixed(3)}
                  )
                </div>
              );
            } else if (data[index].quantity < data[index + 1].quantity) {
              return (
                <div className="color-red">
                  ↓ ({" "}
                  {(data[index].quantity - data[index + 1].quantity).toFixed(3)}
                  )
                </div>
              );
            } else {
              return "=";
            }
          } else {
            return "=";
          }
        } else {
          return "=";
        }
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record, index) => {
        return numberWithCommas(parseFloat(text).toFixed(3));
      },
    },
    {
      title: "unit",
      dataIndex: "unit",
      key: "unit",
      render: (text, record, index) => {
        return product?.unit ? product.unit : "";
      },
    },
  ];

  return (
    <Table
      className={"productBranchLogTable"}
      columns={columns}
      dataSource={data}
      sorter={true}
      pagination={false}
      loading={loading}
      rowKey="id"
      size={"small"}
      rowClassName={(record, index) =>
        record.reason == "wasted"
          ? "redbg"
          : record.reason == "received"
          ? "greenbg"
          : ""
      }
      onRow={(record, rowIndex) => {}}
    />
  );
};

export default Index;
